'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  width: 100vw;\n  height: 100vh;\n  box-sizing: border-box;\n  background-color: rgba(0,0,0,0.5);\n  padding: 2rem;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  width: 100vw;\n  height: 100vh;\n  box-sizing: border-box;\n  background-color: rgba(0,0,0,0.5);\n  padding: 2rem;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 450px;\n\n  @media(max-width: 500px) {\n    width: 99vw;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 450px;\n\n  @media(max-width: 500px) {\n    width: 99vw;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  font-weight: bold;\n  font-size: 2rem;\n  color: #fff;\n  cursor: pointer;\n  pointer-events: auto;\n\n  .fa {\n    margin-left: 0.5rem;\n  }\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  font-weight: bold;\n  font-size: 2rem;\n  color: #fff;\n  cursor: pointer;\n  pointer-events: auto;\n\n  .fa {\n    margin-left: 0.5rem;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  pointer-events: auto;\n  background-color: white;\n  border: 3px solid #ccc;\n  padding: 1rem 2rem;\n  width: 100%;\n\n  actions {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n\n  input {\n    width: 250px;\n    font-size: 1.1rem;\n  }\n\n  button {\n    cursor: pointer;\n    font-size: 1.1rem;\n    background-color: transparent;\n    border: 1px solid #333;\n    &:hover {\n      background-color: #333;\n      color: #fff;\n    }\n  }\n'], ['\n  box-sizing: border-box;\n  pointer-events: auto;\n  background-color: white;\n  border: 3px solid #ccc;\n  padding: 1rem 2rem;\n  width: 100%;\n\n  actions {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n\n  input {\n    width: 250px;\n    font-size: 1.1rem;\n  }\n\n  button {\n    cursor: pointer;\n    font-size: 1.1rem;\n    background-color: transparent;\n    border: 1px solid #333;\n    &:hover {\n      background-color: #333;\n      color: #fff;\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: red;\n  font-weight: bold;\n'], ['\n  color: red;\n  font-weight: bold;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Background = _styledComponents2.default.div(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2);

var Exit = _styledComponents2.default.div(_templateObject3);

var Modal = _styledComponents2.default.div(_templateObject4);

var Warning = _styledComponents2.default.p(_templateObject5);

var RequestLoginLink = function (_Component) {
  _inherits(RequestLoginLink, _Component);

  function RequestLoginLink(props) {
    _classCallCheck(this, RequestLoginLink);

    var _this = _possibleConstructorReturn(this, (RequestLoginLink.__proto__ || Object.getPrototypeOf(RequestLoginLink)).call(this, props));

    _this.state = {
      email: '',
      status: 'pending'
    };
    _this.sendSignInLinkToEmail = _this.sendSignInLinkToEmail.bind(_this);
    return _this;
  }

  _createClass(RequestLoginLink, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(oldProps, newProps) {
      if (newProps.message) this.setState({ message: message });
    }
  }, {
    key: 'sendSignInLinkToEmail',
    value: function sendSignInLinkToEmail() {
      var _this2 = this;

      if (window.vexpo && window.vexpo.firebase) {
        // Send the user a login link
        var actionCodeSettings = {
          url: window.location.protocol + '//' + window.location.host + '/#/lobby',
          handleCodeInApp: true
        };
        window.vexpo.firebase.auth().sendSignInLinkToEmail(this.state.email, actionCodeSettings).then(function () {
          window.localStorage.setItem('emailForSignIn', _this2.state.email);
          _this2.setState({ status: 'sent' });
        }).catch(function (err) {
          if (err.code === 'auth/invalid-email') {
            _this2.setState({
              message: 'That does not appear to be a valid email address.  Please try again.'
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.props.show) return '';

      var message = this.props.newLoginLinkRequired ? _react2.default.createElement(
        Warning,
        null,
        'Your link has already been used or has expired. Please request a new one.'
      ) : '';

      var contents = this.state.status === 'pending' ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Enter your email below to request a personalized login link to the ',
          this.props.name,
          ' to be sent to your email inbox.  Using the link to enter the show will make sure your showbag contains everything you have added to it, even if you logged in previously on another device.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'You will need to request a new link for every device (computer, phone, tablet) you log into the show with.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The email is sent from noreply@vexposhows.com. If you don\'t see it in your inbox, you may need to check your spam folder.'
        ),
        _react2.default.createElement(
          Warning,
          null,
          this.state.message
        ),
        _react2.default.createElement('input', { type: 'email', name: 'email',
          value: this.state.email,
          onChange: function onChange(event) {
            return _this3.setState({ email: event.target.value });
          } }),
        _react2.default.createElement(
          'button',
          { onClick: this.sendSignInLinkToEmail },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'envelope' }),
          ' Send Link'
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Your personalized login link has been sent! Please check your inbox for an email from from ',
          _react2.default.createElement(
            'b',
            null,
            'noreply@vexposhows.com'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'You may need tocheck your spam folder.'
        )
      );

      return _react2.default.createElement(
        Background,
        { id: 'background' },
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            Exit,
            { onClick: this.props.onExit },
            'CANCEL ',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
          ),
          _react2.default.createElement(
            Modal,
            null,
            _react2.default.createElement(
              'h3',
              null,
              'Request Personalized Login Link'
            ),
            contents
          )
        )
      );
    }
  }]);

  return RequestLoginLink;
}(_react.Component);

exports.default = RequestLoginLink;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/request-login-link.js
// module id = 1197
// module chunks = 0